import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { COMPANY, SUPPORT_EMAIL } from '../data/launch';
export function Disclaimer() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-466" data-mp="1awkv5bfv4kbo">
      <SEO title="Disclaimer | KittyPot" description="What KittyPot does and does not do. KittyPot helps groups record and split shared expenses; it does not hold or move customer money." ogTitle="KittyPot Disclaimer" ogDescription="What KittyPot does and does not do." path="/disclaimer" data-id="element-467" data-mp="e50k9575oyko" />
      <Navbar data-id="element-468" data-mp="3rmjc70smgpqc" />
      <main className="pt-32 pb-24" data-id="element-469" data-mp="3rkyhnb6b56sh">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-470" data-mp="3rjx5f3dk2e96">
          <h1 className="text-4xl font-black text-kitty-dark mb-4" data-id="element-471" data-mp="3vmjrennjp4yg">
            Disclaimer
          </h1>
          <p className="text-gray-500 font-medium mb-10" data-id="element-472" data-mp="20m3lbblvui4y">
            Last updated: 26 August 2026
          </p>

          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-473" data-mp="1vp3olraxarqi">
            <p data-id="element-474" data-mp="1qwajv3fgfjef">
              This disclaimer should be read alongside our{' '}
              <Link to="/terms" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-475" data-mp="1lzabumz1o6ko">
                Terms of Use
              </Link>
              . It explains what KittyPot, provided by {COMPANY.legalName}, does
              and does not do.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-476" data-mp="180kgbbrvieyf">
              1. KittyPot is a record-keeping tool
            </h2>
            <p data-id="element-477" data-mp="32d0km713zj0n">
              KittyPot helps you record shared expenses, split them between the
              people involved and keep track of who owes what. It does not give
              financial, tax, legal or accounting advice.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-478" data-mp="vmf5jrs8qgjl">
              2. We do not hold or move money
            </h2>
            <p data-id="element-479" data-mp="lqu3jtn69g9u">
              KittyPot does not hold customer funds, does not act as a wallet
              and does not transfer money between members. Group members settle
              up directly with each other. Marking something as paid in KittyPot
              records that a payment was made elsewhere; it does not make the
              payment.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-480" data-mp="14gts8ff3otcq">
              3. Figures come from you
            </h2>
            <p data-id="element-481" data-mp="19f3lull6flw8">
              Balances, splits and settlement suggestions are calculated from
              the information members enter. Please check amounts, payers and
              splits before relying on them. If something has been entered
              incorrectly, the figures will be wrong.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-482" data-mp="2c77i0hsw97gv">
              4. Receipts and scanned details
            </h2>
            <p data-id="element-483" data-mp="27bs63veg5ln3">
              Where KittyPot reads details from a receipt image, the result is a
              suggestion to save you typing. It may misread an amount or a date,
              so please check it before saving the expense.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-484" data-mp="1tj2gzi3mg0lr">
              5. Currency conversions
            </h2>
            <p data-id="element-485" data-mp="1okr6r69ezo30">
              Converted amounts shown in KittyPot are estimates presented for
              convenience. They may differ from the rate your bank or payment
              provider applies when you actually settle.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-486" data-mp="19tiawfex56hf">
              6. Availability
            </h2>
            <p data-id="element-487" data-mp="15rdj7m816jxf">
              We work to keep KittyPot running, but we cannot guarantee it will
              be available at all times. Maintenance, technical faults or
              third-party outages may interrupt the service.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-488" data-mp="1neehswmelc4q">
              7. Third-party services
            </h2>
            <p data-id="element-489" data-mp="1x726t5756bsw">
              KittyPot relies on third-party services to operate, and our
              website may link to sites we do not control. We are not
              responsible for the content or availability of those third parties.
            </p>

            <h2 className="text-2xl font-bold text-kitty-dark mt-10 mb-4" data-id="element-490" data-mp="269bgjsul6158">
              8. Questions
            </h2>
            <p data-id="element-491" data-mp="2g5endc0dunyi">
              If anything here is unclear, email{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-492" data-mp="2g3bwkpreoqsq">
                {SUPPORT_EMAIL}
              </a>
              . Our responsibility to you is set out in our{' '}
              <Link to="/terms" className="font-semibold text-kitty-dark underline underline-offset-2 hover:text-kitty-yellow-700" data-id="element-493" data-mp="e9p9onin5l78">
                Terms of Use
              </Link>
              , and nothing here affects your legal rights as a consumer.
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-494" data-mp="x5fcue2b8nmp" />
    </div>;
}